import { render, staticRenderFns } from "./ForgotEmail.vue?vue&type=template&id=7530cdb8&"
import script from "./ForgotEmail.vue?vue&type=script&lang=ts&"
export * from "./ForgotEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports